import { hasNames } from "../utils";
import Button from "./button";
import { Link, navigate } from "gatsby";
import * as React from "react";

import CarrotPlanted from "../images/carrot-planted.icon.svg";
import ChevronRightIcon from "../images/chevron-right.icon.svg";
import CompassIcon from "../images/compass-icon.svg";
import logo from "../images/cynosure-logo.png";
import FounderIcon from "../images/founder-icon.svg";
import logoCapitalMGMT from "../images/CynosureCapitalMGMT_Logo_White.png";
import logoPartners from "../images/CynosurePartners_Logo_White.png";
import logoWealth from "../images/CynosureWealth_Logo_White.png";
import logoStrategies from "../images/CynosureWealth_Logo_White.png";
import scrollUpIcon from "../images/scroll-up-icon.svg";

import * as btn from "../styles/button.module.scss";
import * as styles from "../styles/frame.module.scss";
import * as grd from "../styles/grid.module.scss";

const Frame = ({ contained, section = 'wealth', children }) => {
	const [headerOffscreen, setHeaderOffscreen] = React.useState(false);
	const lastWindowScrollY = React.useRef(0);
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const [subMenuOpen, setSubMenuOpen] = React.useState(false);
	const [subMenuTwoOpen, setSubMenuTwoOpen] = React.useState(false);

	function openMobileMenu() {
		setMobileOpen(true);
		setSubMenuTwoOpen(false);
		document.body.classList.add("scrollLocked");
		document.body.classList.add("mobileMenuOpen");
		setHeaderOffscreen(false);
	}
	function closeMobileMenu() {
		setMobileOpen(false);
		document.body.classList.remove("scrollLocked");
		document.body.classList.remove("mobileMenuOpen");
		setHeaderOffscreen(false);
	}
	function toggleMobile() {
		if (mobileOpen) {
			closeMobileMenu();
		} else {
			openMobileMenu();
		}
	}

	function toggleSubMenu() {
		setSubMenuOpen(!subMenuOpen);
		setHeaderOffscreen(false);
		setSubMenuTwoOpen(false);
	}
	function toggleSubMenuTwo() {
		setSubMenuTwoOpen(!subMenuTwoOpen);
		setHeaderOffscreen(false);
		setSubMenuOpen(false);
		closeMobileMenu();
	}

	function navigteToContact() {
		closeMobileMenu();
		navigate("/contact-us/");
	}

	function handleHeaderOffscreen() {
		if (
			window.scrollY < window.innerHeight * 0.666 ||
			lastWindowScrollY.current > window.scrollY
		) {
			setHeaderOffscreen(false);
			document.body.classList.add("header-visible");
		} else {
			setHeaderOffscreen(true);
			document.body.classList.remove("header-visible");
		}
		lastWindowScrollY.current = window.scrollY;
	}

	function swapLogo(section) {
		switch(section) {
			case 'partners':
				return logoPartners;
			case 'advisors':
				return logoCapitalMGMT;
			case 'wealth':
				return logoWealth;
			case 'strategies':
				return logoStrategies;
			default:
				return logoPartners;
		}
	}

	React.useEffect(() => {
		window.addEventListener("scroll", handleHeaderOffscreen, { passive: true });
		return () => {
			window.removeEventListener("scroll", handleHeaderOffscreen);
		};
	}, []);

	return (
		<>
			<div className={styles.modestyCover}></div>
			<header
				id="top"
				className={
					headerOffscreen && !mobileOpen && !subMenuOpen ? styles.offscreen : ""
				}>
				<div className={styles.gridWrap}>
					<div className={styles.logoContainer}>
						<a className={styles.headerLogo} href="https://cynosuregroup.com">
							<img
								src={logo}
								className={styles.logo}
								alt="The Cynosure Group"
							/>
						</a>{" "}
						<span className={styles.headerDivider}></span>
						<button className={styles.headerLogoTwo} onClick={toggleSubMenuTwo}>
							<img
								src={swapLogo(section)}
								className={styles.logoTwo}
								alt="Cynosure Partners"
							/>
							<CarrotPlanted
								className={hasNames(
									styles.submenuTwoCarrot,
									subMenuTwoOpen ? "twoOpen" : ""
								)}
							/>
						</button>
					</div>
					<nav className={hasNames(styles.headerNavigation)}>
						<div className={styles.btnWrap}>
							<Button
								type="tertiary"
								to="/approach/"
								onClick={closeMobileMenu}>
								Approach
							</Button>
						</div>

						<div className={styles.btnWrap}>
							<Button type="tertiary" onClick={closeMobileMenu} to="/team/">
								Team
							</Button>
						</div>
						<div className={styles.btnWrap}>
							<Button type="tertiary" onClick={closeMobileMenu} to="/news">
								News
							</Button>
						</div>
						<div className={styles.btnWrap}>
							<Button
								type="tertiary"
								to="/contact-us/"
								onClick={navigteToContact}>
								Contact Us
							</Button>
						</div>

						<div className={styles.btnWrap}>
							<a
								href="https://cynosure.addepar.com"
								className={hasNames(btn.altSecondary, styles.headerButton)}>
								Investor Portal
							</a>
						</div>
					</nav>
					<button
						className={hasNames(
							styles.mobileMenuBurger,
							mobileOpen ? "opened" : ""
						)}
						onClick={toggleMobile}
						aria-label="Menu">
						<span></span>
						<span></span>
						<span></span>
					</button>
					<div
						className={hasNames(
							styles.subMenuTwo,
							subMenuTwoOpen ? "opened" : ""
						)}>
						<Link
							to={"https://cynosurepartners.com/"}
							onClick={closeMobileMenu}
							className={styles.subMenuItem}>
							<div className={styles.imgSpace}></div>
							<div className={styles.subMenuItemWrap}>
								<span className={hasNames(btn.tertiary, styles.subButton)}>
									Cynosure Partners
								</span>
								<p>
									We invest in founder-led businesses to accelerate growth and
									help create lasting value.
								</p>
								<ChevronRightIcon />
							</div>
						</Link>
						<Link
							to={"https://cynosurecapitalmanagement.com/"}
							onClick={closeMobileMenu}
							className={styles.subMenuItem}>
							<div className={styles.imgSpace}></div>
							<div className={styles.subMenuItemWrap}>
								<span className={hasNames(btn.tertiary, styles.subButton)}>
									Cynosure Capital Management
								</span>
								<p>
									We serve as an outsourced chief investment officer on behalf
									of foundations, endowments, and others.
								</p>
								<ChevronRightIcon />
							</div>
						</Link>
						<Link
							to={"https://cynosurewealthadvisors.com/"}
							onClick={closeMobileMenu}
							className={styles.subMenuItem}>
							<div className={styles.imgSpace}></div>
							<div className={styles.subMenuItemWrap}>
								<span className={hasNames(btn.tertiary, styles.subButton)}>
									Cynosure Wealth Advisors
								</span>
								<p>
									We help families, entrepreneurs, and senior executives navigate
									the challenges that come with substantial wealth.
								</p>
								<ChevronRightIcon />
							</div>
						</Link>
						<Link
							to={"https://cynosurestrategies.co/"}
							onClick={closeMobileMenu}
							className={styles.subMenuItem}>
							<div className={styles.imgSpace}></div>
							<div className={styles.subMenuItemWrap}>
								<span className={hasNames(btn.tertiary, styles.subButton)}>
									Cynosure Strategies
								</span>
								<p>
								We seek uncorrelated absolute returns in our quantitative hedge fund, within Cynosure Strategies.
								</p>
								<ChevronRightIcon />
							</div>
						</Link>
					</div>
				</div>
			</header>

			<main
				className={
					contained !== undefined && contained === "true" ? grd.container : ""
				}>
				{children}
			</main>

			<footer>
				<div className={hasNames(styles.gridWrap)}>
					<a href="/" className={styles.logo}>
						<img src={logo} className={styles.lowerLogo} alt="Cynosure" />
					</a>

					<div className={styles.addresses}>
						<address className={styles.address}>
							<strong className={styles.addressName}>Salt Lake City</strong>
							<div>
								(801) 521-3100
								<br />
								111 S. Main Street, Suite 2350
								<br />
								Salt Lake City, UT 84111
							</div>
						</address>
						<address className={styles.address}>
							<strong className={styles.addressName}>New York City</strong>
							<div>
								(801) 521-3100
								<br />
								888 7th Ave, Suite 2306
								<br />
								New York, NY 10106
							</div>
						</address>
					</div>

					<nav className={styles.footerNav}>
						<div className={styles.tertBtWrp}>
							<Button
								to="/privacy-policy/"
								className={styles.footerLink}
								type="tertiary">
								Privacy Policy
							</Button>
						</div>
						<div className={styles.tertBtWrp}>
							<Button
								to="/legal/"
								className={styles.footerLink}
								type="tertiary">
								Legal
							</Button>
						</div>
						<div className={styles.tertBtWrp}>
							<Button
								to="/advisory-relationship-summary/"
								className={styles.footerLink}
								type="tertiary">
								Client Relationship Summary
							</Button>
						</div>
						<div className={styles.footNavKicker}>
							{/* This space intentionally left blank. */}
						</div>
					</nav>

					<div className={styles.copyright}>
						Copyright {new Date().getFullYear()} &copy; The Cynosure Group
						<br />
						All Rights Reserved
					</div>

					<div className={styles.scrollUp}>
						<button
							className={styles.scrollUpActiveArea}
							onClick={() => {
								window.scrollTo(0, 0);
							}}>
							<div className={styles.scrollUpText}>Back to top</div>
							<br />
							<img
								src={scrollUpIcon}
								className={styles.scrollUpIcon}
								alt="Scroll Up"
							/>
						</button>
					</div>
				</div>
			</footer>
		</>
	);
};

export default Frame;
